// removed by extract-text-webpack-plugin
module.exports = {"guideEditSectionCollapsed":"_3ptc3 _38618 _2kZNz _3Dqep _37W4X _1GX2b _2hwsw _20SLo _3TD8R","guideEditSectionDisabled":"_2uiuf SuKca","guideEditSectionCollapsedIcon":"Ofb-4 raIhq","guideEditSectionCollapsedTitle":"_2Qa0O _2kZNz raIhq","guideEditSectionCollapsedLink":"_1K96C _20SLo qXm3b"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/GuideEditSection.css
// module id = 2650
// module chunks = 3